import React, { Component } from 'react'
import * as R from 'ramda'
import HoverInfo from '../../UniformComponents/HoverInfo'

import './styles/text-area.scss'

class TextArea extends Component {
    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate, props.path)
        }
        this.state = {
            hasEmptyError: false,
            hasFormatError: false,
        }
    }

    componentWillUnmount() {
        const { unregister, name, path } = this.props

        if (typeof unregister === 'function') {
            unregister(name, path)
        }
    }

    validate = ({ value, name }, setState = false) => {
        const { isMandatory, validate, format } = this.props

        const hasValue = R.and(!R.isNil(value), !R.isEmpty(value))
        let isValid = !isMandatory || hasValue
        let hasValidFormat = true
        if (typeof validate === 'function') {
            isValid = isValid && validate({ value, name })
        }

        if (isValid && typeof format === 'function') {
            hasValidFormat = format(value)
        }

        if (setState) {
            this.setState({
                hasEmptyError: !isValid,
                hasFormatError: !hasValidFormat,
            })
        }

        return isValid && hasValidFormat
    }

    onBlur = (e) => {
        const { name, onBlur } = this.props
        const { value } = e.target

        this.validate({ value, name }, true)

        if (typeof onBlur === 'function') {
            onBlur({ value, name })
        }
    }

    render() {
        const {
            name,
            defaultValue,
            value,
            cssClass,
            textAreaCssClass,
            placeholder,
            emptyError,
            formatError,
            label,
            id,
            onChange,
            pattern,
            required,
            style,
            textAreaCssStyle,
            disabled,
            rows,
            cols,
            resize,
            tooltipTitle,
            tooltipText,
            tooltipLinkLabel,
            tooltipLink,
        } = this.props
        const { hasFormatError, hasEmptyError } = this.state

        let textAreaClass = 'textarea'
        textAreaClass += textAreaCssClass ? ` ${textAreaCssClass}` : ''
        textAreaClass += resize ? ` ${resize}` : ''
        textAreaClass += disabled ? ' disabled' : ''
        textAreaClass += (hasEmptyError || hasFormatError) ? ' error' : ''

        if (disabled) {
            return (
                <div className={`form-textarea ${cssClass || ''}`} style={style}>
                    <label htmlFor={id}>
                        {label}
                    </label>
                    <div className={textAreaClass}>{value}</div>
                </div>
            )
        }

        return (
            <div className={`form-textarea ${cssClass || ''}`} style={style}>
                <label htmlFor={id}>
                    {label}
                    {tooltipText && (
                        <HoverInfo
                            cssClass="hover-info"
                            title={tooltipTitle}
                            desc={tooltipText}
                            linkText={tooltipLinkLabel}
                            href={tooltipLink}
                            dir="right"
                        >
                            <i className="info-icon fa-solid fa-circle-question" />
                        </HoverInfo>
                    )}
                </label>
                <textarea
                    name={name}
                    className={textAreaClass}
                    style={textAreaCssStyle}
                    onBlur={this.onBlur}
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    pattern={pattern}
                    required={required}
                    rows={rows}
                    cols={cols}
                />
                {((emptyError && hasEmptyError) || (formatError && hasFormatError)) && (
                    <i className="error-icon fa-regular fa-circle-exclamation" />
                )}
                {((emptyError && hasEmptyError) || (formatError && hasFormatError)) && (
                    <p className="error-msgs">{hasEmptyError ? emptyError : formatError}</p>
                )}
            </div>
        )
    }
}

export default TextArea
